<template>
  <div>
    <b-table striped small fixed responsive="sm" caption-top :items="items" :fields="fields">
      <template slot="table-caption">{{group? group.name: ''}}</template>
      <template slot="value" slot-scope="data">
        <strong>{{data.item.value | beautify}}</strong>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'Group',
  props: {
    id: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
      default: 'Group id'
    },
  },
  data: function() {
    return {
      group: null,
      fields: [
        {key: 'key'},
        {key: 'value'},
      ],
    }
  },
  firestore() {
    return {
      group: this.$firebase.firestore().collection('groups').doc(this.id)
    }
  },
  computed: {
    items() {
      const groupDetails = this.group ? Object.entries(this.group) : [['id', 'Not found']]
      return groupDetails.filter(([key, value]) => {
        return key !== 'users';
      })
      .map(([key, value]) => {
        return {key: key, value: value}
      })
    },
  },
  mounted: function() {

  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
